import React from 'react';
import { Icon, Text, Box, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, LinkBox, LinkOverlay, IconButton, Tooltip, HStack } from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { IoTrashOutline } from 'react-icons/io5';
import { AddressForm } from "../AddressForm";
import { noop } from "../../utils";
export var SelectAddressItem = function SelectAddressItem(props) {
  var name = props.name,
      address = props.address,
      taxId = props.taxId,
      _a = props.onClick,
      onClick = _a === void 0 ? noop : _a,
      _b = props.onDelete,
      onDelete = _b === void 0 ? noop : _b,
      _c = props.onEdited,
      onEdited = _c === void 0 ? noop : _c,
      // onClickSetPrimary = noop,
  _d = props.primary,
      // onClickSetPrimary = noop,
  primary = _d === void 0 ? false : _d,
      _e = props.isSelected,
      isSelected = _e === void 0 ? false : _e,
      addressType = props.addressType;

  var _f = useDisclosure(),
      isOpenDelete = _f.isOpen,
      onOpenDelete = _f.onOpen,
      onCloseDelete = _f.onClose;

  var _g = useDisclosure(),
      isOpenEdit = _g.isOpen,
      onOpenEdit = _g.onOpen,
      onCloseEdit = _g.onClose;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkBox, {
    display: "grid",
    gridTemplateColumns: "1fr 220px",
    gridGap: "4",
    borderBottom: "1px solid",
    borderColor: "gray.200",
    pt: "6",
    pb: "6",
    _last: {
      border: 'none'
    },
    mx: "-24px",
    px: "6",
    backgroundColor: isSelected ? '#f6f6f6' : '#fff'
  }, /*#__PURE__*/React.createElement(LinkOverlay, {
    as: "div",
    cursor: "pointer",
    userSelect: "none",
    layerStyle: "actionable",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    fontWeight: "bold"
  }, name), isSelected && /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, null, "\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35: ", taxId), /*#__PURE__*/React.createElement(Text, null, address))), /*#__PURE__*/React.createElement(HStack, {
    spacing: "1",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    color: "#444"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    label: "\u0E41\u0E01\u0E49\u0E44\u0E02",
    hasArrow: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      as: FiEdit
    }),
    variant: "ghost",
    "data-testid": "address-edit",
    "aria-label": "edit address",
    onClick: onOpenEdit,
    fontSize: "md",
    size: "sm"
  })), /*#__PURE__*/React.createElement(Tooltip, {
    label: "\u0E25\u0E1A",
    hasArrow: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    colorScheme: "red",
    color: "#c63636",
    icon: /*#__PURE__*/React.createElement(Icon, {
      as: IoTrashOutline
    }),
    variant: "ghost",
    "data-testid": "address-edit",
    "aria-label": "edit address",
    onClick: onOpenDelete,
    fontSize: "md",
    size: "sm"
  })))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpenDelete,
    onClose: onCloseDelete,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(ModalHeader, null, "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E19\u0E35\u0E49"), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onCloseDelete,
    mr: 3,
    variant: "outline"
  }, "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"), /*#__PURE__*/React.createElement(Button, {
    colorScheme: "red",
    onClick: function onClick() {
      onDelete();
      onCloseDelete();
    },
    id: "confirm-delete-address-button"
  }, "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19")))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpenEdit,
    onClose: onCloseEdit,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(ModalHeader, null, addressType === 'company' ? 'ที่อยู่สำหรับออกใบกำกับภาษีสำหรับนิติบุคคล' : 'ที่อยู่สำหรับออกใบกำกับภาษีสำหรับบุคคลธรรมดา'), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalBody, {
    mb: "4"
  }, /*#__PURE__*/React.createElement(AddressForm, {
    addressType: addressType,
    onSubmit: function onSubmit(values) {
      onEdited(values);
      onCloseEdit();
    },
    initialValues: {
      primary: primary,
      name: name,
      address: address,
      taxId: taxId
    }
  })))));
};

var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    width: "16px",
    height: "16px",
    backgroundColor: "brand.400",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mr: "2",
    id: "address-check-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    as: FaCheck,
    color: "white",
    boxSize: "10px"
  }));
};